import React from 'react';

const ModalSubmitIcon = () => {
  return (
    <div>
      <svg
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_409_1540)">
          <circle cx="24" cy="24.0366" r="24" fill="#E8F7EB" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36.3543 14.2351C37.5258 15.4067 37.5258 17.3062 36.3543 18.4778L22.2743 32.5578C21.1027 33.7293 19.2032 33.7293 18.0316 32.5578L11.6316 26.1578C10.46 24.9862 10.46 23.0867 11.6316 21.9151C12.8032 20.7436 14.7027 20.7436 15.8742 21.9151L20.1529 26.1938L32.1116 14.2351C33.2832 13.0636 35.1827 13.0636 36.3543 14.2351Z"
            fill="#37A134"
          />
        </g>
        <defs>
          <clipPath id="clip0_409_1540">
            <rect y="0.0366211" width="48" height="48" rx="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default ModalSubmitIcon;
